"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageEventObject = exports.extractMainProperties = exports.extractUserProperties = exports.sendGaEvent = exports.extractComponentTagging = exports.transformObjectKeysToGaFormat = exports.ALLOWED_TCOLAPI_HOST = exports.getMsieVersion = exports.checkSegment = exports.generatePageId = exports.getTabId = exports.isProdBucket = exports.isQaEnv = exports.isLocalHost = exports.setSegmentCookie = exports.isTelcoBuyProcess = exports.isTelcoSite = exports.getUserPersistedInfo = exports.hanTranscurridoSeisMeses = exports.QUEUE_NAME = void 0;
const next13_utils_common_set_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.set-cookie"));
const next13_utils_secure_local_storage_1 = __importDefault(require("@gerenciatd/next13.utils.secure.local-storage"));
exports.QUEUE_NAME = 'Metrics';
const hanTranscurridoSeisMeses = (desde, hasta) => {
    const seisMesesEnMilisegundos = 6 * 30 * 24 * 60 * 60 * 1000; // Asumiendo meses de 30 días
    return hasta - desde >= seisMesesEnMilisegundos;
};
exports.hanTranscurridoSeisMeses = hanTranscurridoSeisMeses;
const getUserPersistedInfo = () => {
    const secureCookieStorageLib = new next13_utils_secure_local_storage_1.default();
    let persistedInfo2Use = {};
    let persistedInfo = secureCookieStorageLib.getItem('ts');
    if (persistedInfo && persistedInfo.ts) {
        // check de los 6 meses
        const currentDate = Date.now();
        const lastTs = persistedInfo && persistedInfo.ts;
        const checkSeisMeses = (0, exports.hanTranscurridoSeisMeses)(lastTs, currentDate);
        if (checkSeisMeses) {
            persistedInfo = {};
            localStorage.removeItem('ts');
        }
        else {
            persistedInfo2Use = Object.assign({}, persistedInfo);
        }
    }
    return persistedInfo2Use;
};
exports.getUserPersistedInfo = getUserPersistedInfo;
const isTelcoSite = () => {
    return window.location.href.indexOf('cliente/areaprivada/#') >= 0;
};
exports.isTelcoSite = isTelcoSite;
const isTelcoBuyProcess = () => {
    return window.location.href.indexOf('/particulares/Aplicaciones/Telco/procesoCompra') >= 0;
};
exports.isTelcoBuyProcess = isTelcoBuyProcess;
const setSegmentCookie = (segment) => {
    try {
        if (segment) {
            (0, next13_utils_common_set_cookie_1.default)('SEG_NAV', segment, 30);
        }
    }
    catch (e) {
        console.error(e);
    }
};
exports.setSegmentCookie = setSegmentCookie;
const isLocalHost = () => {
    let res = false;
    try {
        res = window.location.href.indexOf('127.0.0.1') > -1;
    }
    catch (err) {
        return res;
    }
    return res;
};
exports.isLocalHost = isLocalHost;
const isQaEnv = () => {
    let res = false;
    try {
        res = window.location.href.indexOf('movistar.es.cert') > -1
            || window.location.href.indexOf('qa.cms.col.movistar.es') > -1
            || window.location.href.indexOf('col10mgmt.tsm.inet') > -1;
        return res;
    }
    catch (err) {
        return res;
    }
};
exports.isQaEnv = isQaEnv;
const isProdBucket = () => {
    let res = false;
    try {
        res = window.location.href.indexOf('prod.cms.col.movistar.es') > -1;
        return res;
    }
    catch (err) {
        return res;
    }
};
exports.isProdBucket = isProdBucket;
/**
 * Comprueba si existe tabId
 * @returns {boolean}
 */
const existsTabId = () => {
    try {
        if (window.sessionStorage) {
            return sessionStorage.getItem('mov_tabID') !== null;
        }
        return null;
    }
    catch (err) {
        return null;
    }
};
/**
 * Genera un id para la pestaña actual del navegador.
 * @returns {number}
 */
const generateTabId = () => {
    const tabId = Date.now(); // Todo
    try {
        if (window.sessionStorage) {
            sessionStorage.setItem('mov_tabID', tabId);
            return sessionStorage.getItem('mov_tabID');
        }
        return `notSupportedSessionStorage-${tabId}`;
    }
    catch (err) {
        return `notSupportedSessionStorage-${tabId}`;
    }
};
/**
 * Obtiene el tabId de la pestaña actual.
 * @returns {func}
 */
const getTabId = () => {
    if (existsTabId()) {
        return sessionStorage.getItem('mov_tabID');
    }
    return generateTabId();
};
exports.getTabId = getTabId;
const newID = () => {
    return Math.random().toString(36).substr(2, 9);
};
const generatePageId = () => {
    const uuidArray = [];
    for (let i = 0; i < 6; i++) {
        uuidArray.push(newID());
    }
    const res = uuidArray.join('-');
    try {
        window.pageId = res;
    }
    catch (err) {
        console.log(err);
    }
    return res;
};
exports.generatePageId = generatePageId;
/**
 * Returns page segment
 * @return {string} 'particulares' by default
 */
const checkSegment = () => {
    let res = '';
    // intentamos por url empresas
    const { pathname } = window.location;
    if (pathname.indexOf('/empresas') === 0) {
        res = 'empresas';
    }
    // intentamos por url particulares
    if (pathname.indexOf('/particulares') === 0
        || pathname.indexOf('/cliente/areaprivada') === 0) {
        res = 'particulares';
    }
    const cookieNav = getCookie('SEG_NAV');
    if (!res && cookieNav && cookieNav !== '') {
        res = cookieNav;
    }
    // en caso de no detectar por url, y en caso de que la cookie venga vacía
    if (!res) {
        res = 'particulares';
    }
    return res;
};
exports.checkSegment = checkSegment;
const getMsieVersion = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./));
};
exports.getMsieVersion = getMsieVersion;
exports.ALLOWED_TCOLAPI_HOST = [
    'col10mgmt.tsm.inet',
    'movistar.es',
    'www.movistar.es',
    'movistar.cert',
    'www.movistar.cert',
];
const sendGaPageEvent = (eventType) => {
    let eventValue = 'page_printed';
    if (eventType === 'view') {
        eventValue = 'page_view';
    }
    window.gtag('event', eventValue);
};
const transformObjectKeysToGaFormat = (object) => {
    let result = {};
    const keys = object ? Object.keys(object) : [];
    keys.forEach(keyName => {
        const newKey = keyName.replace(/-/g, '_');
        const value = object[keyName];
        result[newKey] = value;
    });
    return result;
};
exports.transformObjectKeysToGaFormat = transformObjectKeysToGaFormat;
const extractComponentTagging = (contextObj) => {
    let res = {
        'event_type': contextObj['event_type'],
        'component_name': contextObj['component_name'],
        'component_content': contextObj['component_content'],
        'component_product': contextObj['component_product'],
        'component_perso': JSON.stringify(contextObj['component_perso']),
        'component_variation': contextObj['component_variation'],
    };
    return res;
};
exports.extractComponentTagging = extractComponentTagging;
const sendGaComponentEvent = (contextObj) => {
    if (contextObj && contextObj.event) {
        delete contextObj.event;
    }
    const componentTaggingInfo = (0, exports.extractComponentTagging)(contextObj);
    window.gtag('event', 'cms_component', Object.assign({}, componentTaggingInfo));
};
const sendGaEvent = (contextObj) => {
    try {
        const gaObject = (0, exports.transformObjectKeysToGaFormat)(contextObj);
        const event = gaObject['event'];
        const eventType = gaObject['event_type'];
        const componentTagging = event.indexOf('component') !== -1;
        const printEvent = eventType.indexOf('print') !== -1;
        if (event === 'cms-page' && eventType) {
            sendGaPageEvent(eventType);
        }
        else if (componentTagging || printEvent) {
            // para los eventos de customizer
            sendGaComponentEvent(gaObject);
        }
        else {
            window.gtag('event', gaObject);
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.sendGaEvent = sendGaEvent;
const extractUserProperties = (contextObj) => {
    let res = {
        'context_ga_cookie': contextObj['context-ga-cookie'],
        'user_client': contextObj['user-client'],
        'user_consent_cookie_onetrust': contextObj['user-consent-cookie-onetrust'],
        'user_cuc_fijo_hash': contextObj['user-cuc-fijo-hash'],
        'user_cuc_movil_hash': contextObj['user-cuc-movil-hash'],
        'user_cuc_prepago_hash': contextObj['user-cuc-prepago-hash'],
        'user_id_party_hash': contextObj['user-id-party-hash'],
        'user_ip_hash': contextObj['user-ip-hash'],
        'user_operador_hash': contextObj['user-operador-hash'],
        'user_priority': contextObj['user-priority'],
        'user_telefono_fijo_hash': contextObj['user-telefono-fijo-hash'],
        'user_telefono_movil_hash': contextObj['user-telefono-movil-hash'],
        'user_type': contextObj['user-type'],
    };
    return res;
};
exports.extractUserProperties = extractUserProperties;
const extractMainProperties = (contextObj) => {
    let res = {
        'page_name': contextObj['page-name'],
        'page_product_code': contextObj['page-product-code'],
        'page_product_name': contextObj['page-product-name'],
        'page_segment': contextObj['page-segment'],
        'context_page_id': contextObj['context-page-id'],
        'context_seo_meta': contextObj['context-seo-meta'],
        'context_session_id': contextObj['context-session-id'],
        'context_tab_id': contextObj['context-tab-id'],
        'context_url': contextObj['context-url'],
    };
    return res;
};
exports.extractMainProperties = extractMainProperties;
const createPageEventObject = (data) => {
    if (!data) {
        return null;
    }
    const { clientIDs, userType: userTypeFromData } = data;
    const { event = 'cms-page', eventType = '', tabId = '', pageName = '', pageProductCode = '', pageProductName = '', contextGaCookie = (clientIDs && clientIDs.ga) || null, contextSessionId = (clientIDs && clientIDs.sessId) || null, contextPageId = (clientIDs && clientIDs.pageId) || null, userCUCFijoHash = '', userCUCMovilHash = '', userCUCPrepagoHash = '', userIPHash = '', userOperadorHash = '', userTelefonoFijoHash = '', userTelefonoMovilHash = '', userIdPartyHash = '', userType = '', pageSegment = '', contextURL = '', userClient = !!userTypeFromData, contextSeoMeta = '', } = data;
    return {
        event,
        'event-type': eventType,
        'context-tab-id': tabId,
        'page-name': pageName,
        'page-product-code': pageProductCode,
        'page-product-name': pageProductName,
        // client id de ga
        'context-ga-cookie': contextGaCookie,
        // id de sesión de la navegación del usuario
        'context-session-id': contextSessionId,
        // page id de la página
        'context-page-id': contextPageId,
        'user-cuc-fijo-hash': userCUCFijoHash,
        'user-cuc-movil-hash': userCUCMovilHash,
        'user-cuc-prepago-hash': userCUCPrepagoHash,
        'user-ip-hash': userIPHash,
        'user-operador-hash': userOperadorHash,
        'user-telefono-fijo-hash': userTelefonoFijoHash,
        'user-telefono-movil-hash': userTelefonoMovilHash,
        'user-id-party-hash': userIdPartyHash,
        // telco o legado
        'user-type': userType,
        // segmento de navegación de la página
        'page-segment': pageSegment,
        // url de la página
        'context-url': contextURL,
        // true o false si es cliente o no
        'user-client': userClient,
        // meta description de seo
        'context-seo-meta': contextSeoMeta,
    };
};
exports.createPageEventObject = createPageEventObject;
//# sourceMappingURL=utils.js.map